export default __webpack_public_path__ + "3dd6a50f4613f44d94903aef24116557.png";